module.exports = __webpack_public_path__ + "static/img/forests03.5b4a5d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/forests03.jpg
// module id = 6PzS
// module chunks = 0